var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('view-finance', 'Yacht'))?_c('div',[_vm._v(" finance ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }